module.exports = __webpack_public_path__ + "static/media/Envios.98089c0d.svg";